/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, centerAbsolutely, fullSize, answerSelect } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : EMBED BACKGROUND : STYLES --------------- ++++++++++ */
export default theme => ({
	background: {
		borderRadius: 'inherit',
		extend: [centerAbsolutely, fullSize, answerSelect],
		zIndex: '1',
		cursor: 'pointer',
    '& .imageprocessingnote': {
      position: 'absolute',
      top: '8px',
      left: '6px',
      background: '#FFAE22',
      opacity: 0.8,
      zIndex: 999,
      display: 'flex',
      alignItems: 'center',
      gap: 0,
      padding: '4px',
      borderRadius: '8px',
      fontSize: '12px',
      color: '#fff',
      '& .icon': {
        margin: '0 6px',
        fontSize: '18px'
      },
      '& .tooltip': {
        color: '#fff',
        '& .icon': {
          fontSize: '12px'
        }
      }
    },
		'& .fade': {
			borderRadius: 'inherit',
			extend: [centerAbsolutely, fullSize],
			zIndex: '2',
			// background color comes from component itself dynamically
			// helpful gradient generator below
			// http://angrytools.com/gradient/
			// background: "radial-gradient(ellipse at center, rgba(82,83,84,0.65) 0%, rgba(0,10,10,0.7) 100%)" /* w3c */
		},
		'& .image': {
			borderRadius: 'inherit',
			transition: 'background-image .2s linear 0s',
			extend: [centerAbsolutely, fullSize],
			zIndex: '1',
			// backgroundColor: '#000',
			backgroundPosition: '50% 50%',
			backgroundRepeat: 'no-repeat',
			backgroundSize: 'cover'
			// backgroundImage added dynamically as inline style from component file which pulls it from content data
		},
    '& .imagepreview': {
      objectFit: 'cover',
      visibility: 'hidden'
    },
		'& .imageindicator': {
			position: 'absolute',
			bottom: pxToEm(10),
			left: pxToEm(10),
			display: 'flex',
			justifyContent: 'center',
			alignItems: 'center',
			height: pxToEm(34),
			width: pxToEm(34),
		}
	}
});
